import { P, shadow } from "../../styles/tokens";

export default function Card({ children, style = {}, onClick, pad = "20px", radius = 16 }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: P.surface,
        borderRadius: radius,
        padding: pad,
        border: `1px solid ${P.border}`,
        boxShadow: shadow(),
        ...style,
      }}
    >
      {children}
    </div>
  );
}
